import Keycloak from 'keycloak-js'
import BerechtigungUtil from './services/BerechtigungUtil'

fetch('./config/config.json', {cache: 'reload'})
  .then(res => res.json())
  .then(config => {
    window.keycloak = new Keycloak({
      url: config.ssoUrl,
      realm: config.ssoRealm,
      clientId: config.ssoClient
    })
    window.keycloak.init({
      onLoad: 'login-required',
      promiseType: 'native',
      checkLoginIframe: false,
      pkceMethod: 'S256'
    }).then(authenticated => {
      Promise.resolve(
        new BerechtigungUtil().refreshUserProfiles()
      ).then(() => {
        document.querySelector('body').innerHTML = `
<main>
  <div id="mainheader">
    <eko-frontend-header></eko-frontend-header>
    <eko-frontend-horizontal-navigation></eko-frontend-horizontal-navigation>
  </div>
  <div id="maincontent">
    <isceco-message lifetime="10"></isceco-message>
    <eko-frontend-main-view></eko-frontend-main-view>
    <isceco-scroll-top></isceco-scroll-top>
  </div>
  <div id="mainfooter">
    <eko-frontend-footer></eko-frontend-footer>
  </div>
</main>
                `
      })
    })

    // used for Global Logout context
    window.keycloak.onTokenExpired = () => {
      keycloak.updateToken(-1)
        .catch(function () {
          console.error('Failed to refresh the token, or the session has expired') // NOSONAR
          keycloak.login()
        })
    }
  })
